export default __webpack_public_path__ + "graphik-semibold.woff2";